"use client";

import Image, { StaticImageData } from "next/image";
/*import "./FaIcon.scss";*/

const FaIcon = ({ id, href, imgSrc }: { id?: string; href: string; imgSrc?: StaticImageData | string }) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    className={`fa-stack mx-1 mx-lg-0 me-lg-2 FaIcon`}
  >
    <i className="fa fa-circle fa-stack-2x" />
    {imgSrc ? (
      <img src={typeof imgSrc === "string" ? imgSrc : (imgSrc as StaticImageData).src} alt="" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "14px", height: "auto" }} />
    ) : (
      <i className={`fa ${id} fa-stack-1x fa-inverse`} />
    )}
  </a>
);

export default FaIcon;
